import { ChangeDetectorRef, Directive, Inject, InjectionToken, OnInit } from "@angular/core";
import { UntilDestroy, untilDestroyed } from "@ngneat/until-destroy";
import { debounceTime, distinctUntilChanged } from "rxjs";
import { IsNavigationExpandedCache } from "@webapp/navigation/services/is-navigation-expanded.cache";
import { updateVisibleLabels } from "@webapp/reflections/utils";
import { WidthResizeObservable } from "@webapp/ui/core/core.utils";

export interface CollapsePanelConfig {
  compareMode: boolean;
}

export const COLLAPSE_PANEL_CONFIG_TOKEN = new InjectionToken<CollapsePanelConfig>("CollapsePanelConfig");

@UntilDestroy()
@Directive({ selector: "[collapse-panel-header]" })
export class CollapsePanelHeaderDirective implements OnInit {
  public isLeftNavigationEnabled: boolean;
  public maxVisibleLabels: number;

  constructor(
    private isNavExpanded: IsNavigationExpandedCache,
    private cdr: ChangeDetectorRef,
    @Inject(COLLAPSE_PANEL_CONFIG_TOKEN) private config: CollapsePanelConfig
  ) {}

  public ngOnInit(): void {
    new WidthResizeObservable(document.body).pipe(debounceTime(200), distinctUntilChanged(), untilDestroyed(this)).subscribe((width) => {
      this.maxVisibleLabels = updateVisibleLabels({
        currentBrowserWidth: width,
        isLeftNavigationEnabled: this.isLeftNavigationEnabled,
        compareMode: this.config.compareMode,
      });
      this.cdr.detectChanges();
    });

    this.isNavExpanded
      .get$()
      .pipe(untilDestroyed(this))
      .subscribe((value) => {
        this.isLeftNavigationEnabled = value;
        this.maxVisibleLabels = updateVisibleLabels({
          currentBrowserWidth: window.innerWidth,
          isLeftNavigationEnabled: this.isLeftNavigationEnabled,
          compareMode: this.config.compareMode,
        });
        this.cdr.detectChanges();
      });
  }
}
